/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import { Box, IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "../../../../components/common/Modal/Modal";
import Typography from "../../../../components/common/new/Typography/Typography";
import Loader from "../../../../components/common/Loader/Loader";
import StatusBlock from "./Components/StatusBlock";

// Status order for OKATAKI_GOHONZON flow
const OKATAKI_STATUS_ORDER = [
  "INITIATED",
  "DRAFT",
  "VERIFIED",
  "SUBMITTED",
  "REGION_APPROVED",
  "INTERVIEWED",
  "BATCH_CREATED",
  "ALLOTTED",
  "HANDOVER",
  "CONFERRED",
];

function isStatusReached(currentStatus, targetStatus) {
  const currentIdx = OKATAKI_STATUS_ORDER.indexOf(currentStatus);
  const targetIdx = OKATAKI_STATUS_ORDER.indexOf(targetStatus);
  // If status not in list (e.g. ALLOTMENT_CANCELLED), treat as after BATCH_CREATED
  if (currentIdx === -1) return true;
  return currentIdx >= targetIdx;
}

function TrackingModal({ open, onClose, isVotingLoading, memberData }) {
  const isOkataki = memberData?.gohonzonType === "OKATAKI_GOHONZON";
  const isOmamori = memberData?.gohonzonType === "OMAMORI_GOHONZON";

  return (
    <Modal
      open={open}
      onClose={onClose}
      customStyle={{
        overflowY: "auto",
        overflowX: "auto",
        minWidth: "30%",
        maxHeight: "95%",
        width: "50%",
        maxWidth: "95%",
        borderRadius: "14px",
        background: "#FFF",
      }}
    >
      <Box
        style={{
          position: "sticky",
          top: -20,
          zIndex: 1,
          background: "#FFF",
          paddingBottom: "5px",
          display: "flex",
          justifyContent: "space-between",
          gap: "1rem",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          style={{
            color: "#8C8C8C",
            fontSize: "20px ",
            fontWeight: "500",
            paddingLeft: "12px",
          }}
        >
          Gohonzon Application Status{" "}
        </Typography>
        <IconButton>
          <CloseIcon onClick={onClose} />
        </IconButton>
      </Box>
      <Box>
        <div style={{ width: "100%" }}>
          <Box mt={1} />

          <Box>
            <StatusBlock
              title="Initiated"
              name={memberData?.appliedBy}
              date={memberData?.appliedAt}
              resendConsent
              memberData={memberData}
            />

            <Box mt={6} />

            <StatusBlock
              title="Member Consent"
              name={
                memberData?.status !== "DRAFT" &&
                memberData?.memberDetails?.fullName
              }
              date={memberData?.consentProvidedAt}
            />

            <Box mt={6} />

            <StatusBlock
              title="Chapter Approved"
              name={memberData?.submittedBy}
              date={memberData?.submittedAt}
            />

            <Box mt={6} />

            <StatusBlock
              title="Region Approved"
              name={memberData?.regionApprovedBy}
              date={memberData?.regionApprovedAt}
            />

            {/* ✅ FIX: Dono OKATAKI steps hamesha dikhenge agar gohonzonType match kare */}
            {isOkataki && (
              <>
                <Box mt={6} />
                <StatusBlock
                  title="Ready for Batch"
                  name={
                    isStatusReached(memberData?.status, "INTERVIEWED")
                      ? memberData?.regionApprovedBy
                      : null
                  }
                  date={
                    isStatusReached(memberData?.status, "INTERVIEWED")
                      ? memberData?.regionApprovedAt
                      : null
                  }
                />
              </>
            )}

            {isOkataki && (
              <>
                <Box mt={6} />
                <StatusBlock
                  title="Batch Created"
                  name={
                    isStatusReached(memberData?.status, "BATCH_CREATED")
                      ? memberData?.regionApprovedBy
                      : null
                  }
                  date={
                    isStatusReached(memberData?.status, "BATCH_CREATED")
                      ? memberData?.regionApprovedAt
                      : null
                  }
                  showBatchId={isStatusReached(
                    memberData?.status,
                    "BATCH_CREATED"
                  )}
                  memberData={memberData}
                  batchId={memberData?.batchApplicationId}
                />
              </>
            )}

            {isOmamori && (
              <>
                <Box mt={6} />
                <StatusBlock
                  title="Zone Approved"
                  name={memberData?.zoneApprovedBy}
                  date={memberData?.zoneApprovedAt}
                />
              </>
            )}

            <Box mt={6} />

            <StatusBlock
              title="Alloted(BSG HQ)"
              name={memberData?.allottedByName}
              date={memberData?.allotedAt}
            />

            <Box mt={6} />

            <StatusBlock
              title="Handover(BSG HQ)"
              name={memberData?.handoverToName}
              date={memberData?.handoverAt}
              isHandover
            />

            {memberData?.status !== "ALLOTMENT_CANCELLED" &&
              memberData?.status !== "ALLOTMENT_CANCELLATION_REQUESTED" && (
                <>
                  <Box mt={6} />
                  <StatusBlock
                    title="Conferral"
                    name={memberData?.conferredBy}
                    date={memberData?.conferredDate}
                  />
                </>
              )}

            {(memberData?.status === "ALLOTMENT_CANCELLATION_REQUESTED" ||
              memberData?.status === "ALLOTMENT_CANCELLED") && (
              <>
                <Box mt={6} />
                <StatusBlock
                  title="Cancel Requested"
                  name={memberData?.cancelRequestedByName}
                  date={memberData?.cancelRequestedAt}
                  isCancelled
                />
              </>
            )}

            {memberData?.status === "ALLOTMENT_CANCELLED" && (
              <>
                <Box mt={6} />
                <StatusBlock
                  title="Cancelled"
                  name={memberData?.cancelledByName}
                  date={memberData?.handoverAt}
                  isCancelled
                />
              </>
            )}
          </Box>
        </div>
      </Box>
      {isVotingLoading && <Loader />}
    </Modal>
  );
}

export default TrackingModal;
